import Modal from 'components/Modal'
import PurchaseRedemptionReversalTx from 'views/MemberProfile/ManualTx/PurchaseRedemptionReversalTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalPurchaseRedepmtionReversal = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <PurchaseRedemptionReversalTx onClose={onClose} />
    </Modal>
  )
}

export default ModalPurchaseRedepmtionReversal
